"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventLabel = exports.Event = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var Event;
(function (Event) {
    Event["ISSUE_CREATED"] = "issue_raised";
    Event["ISSUE_ASSIGNED"] = "issue_assigned";
    Event["ISSUE_COMMENT"] = "issue_comment";
    Event["ISSUE_STATUS_CHANGED"] = "issue_status_changed";
    Event["ISSUE_CLOSED"] = "issue_closed";
    Event["ISSUE_MISSED"] = "issue_missed";
    Event["WORKFLOW_ASSOCIATED_DATA_CHANGED"] = "workflow_associated_data_changed";
    Event["OP_LATE"] = "op_late";
    Event["OP_SUBMITTED"] = "op_submitted";
    Event["OP_COMPLETE"] = "op_complete";
    Event["OP_DUE"] = "op_due";
    Event["OP_MISSED"] = "op_missed";
    Event["ASSET_SENSOR_CHANGED"] = "asset_sensor_changed";
    Event["SENSOR_READING"] = "sensor_reading";
    Event["SCHEDULE"] = "schedule";
    Event["MESSAGE_ADDED"] = "message_added";
    Event["IMAGE_UPLOADED"] = "image_uploaded";
    Event["TASK_CREATED"] = "task_created";
    Event["TASK_CHILDFINISHED"] = "task_child_finished";
    Event["TASK_PARENT_FAILED"] = "task_parent_failed";
    Event["TASK_PARENT_SUCCEEDED"] = "task_parent_succeeded";
    Event["AUDITABLE_FIELD_UPDATED"] = "auditable_field_updated";
    Event["ORG_CREATED"] = "org_created";
    Event["ORG_SETTINGS_UPDATED"] = "org_settings_updated";
    Event["ONBOARDING_TRIGGERED"] = "onboarding_triggered";
    Event["ONBOARDING_SKIPPED"] = "onboarding_skipped";
    Event["ONBOARDING_COMPLETED"] = "onboarding_completed";
    Event["ONBOARDING_ABANDONED"] = "onboarding_abandoned";
    Event["ORG_FIRSTOPPLAN_CREATED"] = "org_firstopplan_created";
    Event["ORG_FIRSTTEAM_CREATED"] = "org_firstteam_created";
    Event["ORG_FIRSTPLACE_CREATED"] = "org_firstplace_created";
    Event["ORG_FIRSTPOSITION_CREATED"] = "org_firstposition_created";
    Event["ORG_FIRSTISSUE_CREATED"] = "org_firstissue_created";
    Event["ORG_FIRSTSTAFF_CREATED"] = "org_firststaff_created";
    Event["ORG_FIRSTTEAMBOARD_CREATED"] = "org_firstteamboard_created";
    Event["ORG_NATIVEAPP_OPENED"] = "org_nativeapp_opened";
    Event["ORG_WEBAPP_ACCESSED"] = "org_webapp_accessed";
})(Event = exports.Event || (exports.Event = {}));
exports.default = Event;
function eventLabel(event) {
    switch (event) {
        case Event.ISSUE_CREATED:
            return lib_i18n_1.default.t('issue_raised_simple');
        case Event.ISSUE_ASSIGNED:
            return lib_i18n_1.default.t('issue_assigned_simple');
        case Event.ISSUE_COMMENT:
            return lib_i18n_1.default.t('issue_comment_simple');
        case Event.ISSUE_STATUS_CHANGED:
            return lib_i18n_1.default.t('issue_status_changed_simple');
        case Event.ISSUE_CLOSED:
            return lib_i18n_1.default.t('issue_closed_simple');
        case Event.ISSUE_MISSED:
            return lib_i18n_1.default.t('issue_missed_simple');
        case Event.OP_LATE:
            return lib_i18n_1.default.t('op_late_simple');
        case Event.OP_SUBMITTED:
            return lib_i18n_1.default.t('op_submitted_simple');
        case Event.OP_COMPLETE:
            return lib_i18n_1.default.t('op_complete_simple');
        case Event.OP_DUE:
            return lib_i18n_1.default.t('op_due_simple');
        case Event.OP_MISSED:
            return lib_i18n_1.default.t('op_missed_simple');
        case Event.SENSOR_READING:
            return lib_i18n_1.default.t('sensor_reading_simple');
        case Event.MESSAGE_ADDED:
            return lib_i18n_1.default.t('message_added_simple');
        case Event.IMAGE_UPLOADED:
            return lib_i18n_1.default.t('image_uploaded_simple');
        case Event.TASK_CREATED:
            return lib_i18n_1.default.t('task_created_simple');
        case Event.TASK_CHILDFINISHED:
            return lib_i18n_1.default.t('task_child_finished_simple');
        case Event.TASK_PARENT_FAILED:
            return lib_i18n_1.default.t('task_parent_failed_simple');
        case Event.TASK_PARENT_SUCCEEDED:
            return lib_i18n_1.default.t('task_parent_succeeded_simple');
        case Event.AUDITABLE_FIELD_UPDATED:
            return lib_i18n_1.default.t('auditable_field_updated_simple');
        case Event.ORG_CREATED:
            return lib_i18n_1.default.t('org_created_simple');
        case Event.ORG_SETTINGS_UPDATED:
            return lib_i18n_1.default.t('org_settings_updated_simple');
        case Event.ONBOARDING_TRIGGERED:
            return lib_i18n_1.default.t('onboarding_triggered_simple');
        case Event.ONBOARDING_SKIPPED:
            return lib_i18n_1.default.t('onboarding_skipped_simple');
        case Event.ONBOARDING_COMPLETED:
            return lib_i18n_1.default.t('onboarding_completed_simple');
        case Event.ONBOARDING_ABANDONED:
            return lib_i18n_1.default.t('onboarding_abandoned_simple');
        case Event.ORG_FIRSTOPPLAN_CREATED:
            return lib_i18n_1.default.t('org_firstopplan_created_simple');
        case Event.ORG_FIRSTTEAM_CREATED:
            return lib_i18n_1.default.t('org_firstteam_created_simple');
        case Event.ORG_FIRSTPLACE_CREATED:
            return lib_i18n_1.default.t('org_firstplace_created_simple');
        case Event.ORG_FIRSTPOSITION_CREATED:
            return lib_i18n_1.default.t('org_firstposition_created_simple');
        case Event.ORG_FIRSTISSUE_CREATED:
            return lib_i18n_1.default.t('org_firstissue_created_simple');
        case Event.ORG_FIRSTSTAFF_CREATED:
            return lib_i18n_1.default.t('org_firststaff_created_simple');
        case Event.ORG_FIRSTTEAMBOARD_CREATED:
            return lib_i18n_1.default.t('org_firstteamboard_created_simple');
        case Event.ORG_NATIVEAPP_OPENED:
            return lib_i18n_1.default.t('org_nativeapp_opened_simple');
        case Event.ORG_WEBAPP_ACCESSED:
            return lib_i18n_1.default.t('org_webapp_accessed_simple');
        case Event.SCHEDULE:
            return lib_i18n_1.default.t('schedule');
    }
    return '';
}
exports.eventLabel = eventLabel;
